(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drinks-product-main"] && !Shopify.designMode) return;
  try {
    
function initDrinksProductMain(root) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  const smoother = window.ScrollSmoother && ScrollSmoother.get ? ScrollSmoother.get() : null;
  const scroller = smoother ? smoother.wrapper() : window;
  const scope = root && root.querySelectorAll ? root : document;
  const sections = [];

  if (scope !== document && scope.matches && scope.matches('section.drinks-product-main')) {
    sections.push(scope);
  }

  scope.querySelectorAll('section.drinks-product-main').forEach(section => {
    sections.push(section);
  });

  sections.forEach(section => {
    if (section.dataset.drinksProductMainInitialized === 'true') {
      return;
    }
    section.dataset.drinksProductMainInitialized = 'true';

    if (window.matchMedia("(min-width: 768px)").matches) {
      const ingredientWrap = section.querySelector('.ingredient-stack-wrap');
      const ingredientCards = section.querySelectorAll('.ingredient-card');
      const mediaObjects = section.querySelectorAll('.drinks-product-main__media-object');
      const mediaContainer = section.querySelector('.drinks-product-main__media');

      if (!mediaObjects.length || !ingredientCards.length || !mediaContainer || !ingredientWrap) return;

      // Start with front visible; only toggle a back image if one exists.
      gsap.set(mediaObjects[0], { opacity: 1 });
      if (mediaObjects[1]) {
        gsap.set(mediaObjects[1], { opacity: 0 });
      }

      // Swap helper
      function showFront() {
        gsap.to(mediaObjects, { opacity: 0, duration: 0.5 });
        gsap.to(mediaObjects[0], { opacity: 1, duration: 0.5 });
      }

      function showBack() {
        gsap.to(mediaObjects, { opacity: 0, duration: 0.5 });
        gsap.to(mediaObjects[1], { opacity: 1, duration: 0.5 });
      }

      if (mediaObjects[1]) {
        ScrollTrigger.create({
          trigger: ingredientWrap,
          start: "top center",
          end: "bottom center",
          scroller: scroller,
          onEnter: showBack,
          onLeaveBack: showFront
        });
      }

      // Pin the media
      ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: "bottom 80%",
        pin: mediaContainer,
        scroller: scroller,
        anticipatePin: 1
      });
    }
  });
}

function runDrinksProductMainInit(root) {
  if (window.__gsapReady) {
    initDrinksProductMain(root);
    return;
  }
  window.addEventListener('gsap:ready', function () {
    initDrinksProductMain(root);
  }, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    runDrinksProductMainInit(document);
  });
} else {
  runDrinksProductMainInit(document);
}

document.addEventListener('shopify:section:load', function (event) {
  runDrinksProductMainInit(event && event.target ? event.target : document);
});

if (!window.__drinksProductMainLoadRefreshBound) {
  window.__drinksProductMainLoadRefreshBound = true;
  window.addEventListener('load', () => {
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-main"]) return;
  try {
    
  document.querySelector('.footer__form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const msgInvalidEmail = form.dataset.msgInvalidEmail || 'Please enter a valid email address.';
    const msgSubscribed = form.dataset.msgSubscribed || 'You\'re subscribed!';
    const msgConfirm = form.dataset.msgConfirm || 'Thanks - check your inbox to confirm your subscription.';
    const msgError = form.dataset.msgError || 'Something went wrong. Please try again.';
    const email = form.querySelector('#footer-email').value.trim();
    const msg = document.getElementById('footer-signup-status');
    msg.classList.remove('visually-hidden', 'color-success', 'color-error');
    
    if (!email) {
      msg.classList.add('color-error');
      msg.textContent = msgInvalidEmail;
      return;
    }
    
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.classList.add('color-error');
      msg.textContent = msgInvalidEmail;
      return;
    }
    
    const body = new URLSearchParams(new FormData(form));
    const r = await fetch(form.action, {
      method: form.method || 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body
    });

    const data = await r.json();
    msg.classList.remove('color-success', 'color-error');
    
    if (data.success) {
      msg.classList.add('color-success');
      msg.textContent = data.data.is_subscribed ? msgSubscribed : msgConfirm;
      form.reset();
    } else {
      msg.classList.add('color-error');
      msg.textContent = msgError;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-main"]) return;
  try {
    
function initHeaderMain(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var headers = [];

  if (scope !== document && scope.matches && scope.matches('.site-header')) {
    headers.push(scope);
  }

  scope.querySelectorAll('.site-header').forEach(function (header) {
    headers.push(header);
  });

  headers.forEach(function (header) {
    var toggle = header.querySelector('.header__menu-toggle');
    var navClose = header.querySelector('.header__nav-close');
    if (header.dataset.headerMainInitialized === 'true') return;
    header.dataset.headerMainInitialized = 'true';

    var openClass = 'header--menu-open';

    function openMenu() {
      header.classList.add(openClass);
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      header.classList.remove(openClass);
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (header.classList.contains(openClass)) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    }

    if (navClose) {
      navClose.addEventListener('click', function () {
        closeMenu();
      });
    }
  });

  if (window.__headerMainGlobalsBound) return;
  window.__headerMainGlobalsBound = true;

  function closeOpenHeaders(target) {
    document.querySelectorAll('.site-header.header--menu-open').forEach(function (header) {
      if (target && header.contains(target)) return;
      header.classList.remove('header--menu-open');
      var toggle = header.querySelector('.header__menu-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (evt) {
    closeOpenHeaders(evt.target);
  });

  document.addEventListener('touchstart', function (evt) {
    closeOpenHeaders(evt.target);
  }, { passive: true });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') closeOpenHeaders();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initHeaderMain(document);
  });
} else {
  initHeaderMain(document);
}

document.addEventListener('shopify:section:load', function (event) {
  initHeaderMain(event && event.target ? event.target : document);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal-supplement-facts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modals = document.querySelectorAll("[data-modal][id]");
  
    if (!modals.length) return;
  
    function getFocusableElements(container) {
      return container.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
    }
  
    function trapFocus(e, dialog) {
      if (e.key !== "Tab") return;
  
      var focusable = getFocusableElements(dialog);
      if (!focusable.length) return;
  
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
  
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  
    modals.forEach(function (modalEl) {
      var dialog = modalEl.querySelector(".supplement-facts-details");
      var backdrop = modalEl.querySelector("[data-modal-backdrop]");
      var closeBtn = modalEl.querySelector("[data-close-details]");
      var lastTrigger = null;
  
      if (!dialog || !backdrop) return;
  
      function onKeyDown(e) {
        if (e.key === "Escape") {
          e.preventDefault();
          closeModal();
          return;
        }
        trapFocus(e, dialog);
      }
  
      function openModal(trigger) {
        lastTrigger = trigger || null;
  
        if (modalEl.classList.contains("is-open")) return;
  
        modalEl.classList.add("is-open");
        modalEl.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("modal-active");
  
        dialog.focus();
        document.addEventListener("keydown", onKeyDown);
      }
  
      function closeModal() {
        if (!modalEl.classList.contains("is-open")) return;
  
        modalEl.classList.remove("is-open");
        modalEl.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("modal-active");
  
        document.removeEventListener("keydown", onKeyDown);
  
        if (lastTrigger && typeof lastTrigger.focus === "function") {
          lastTrigger.focus();
        }
      }
  
      // Click on backdrop to close
      backdrop.addEventListener("click", function (e) {
        if (e.target === backdrop) {
          closeModal();
        }
      });
  
      // Close button
      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          closeModal();
        });
      }
  
      // Expose open function for external triggers
      modalEl._openModal = openModal;
    });
  
    // External triggers: data-open-modal="supplement-facts-modal"
    var openButtons = document.querySelectorAll("[data-open-modal]");
  
    openButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var targetId = btn.getAttribute("data-open-modal");
        if (!targetId) return;
  
        var modal = document.getElementById(targetId);
        if (!modal || !modal.hasAttribute("data-modal")) return;
  
        if (typeof modal._openModal === "function") {
          modal._openModal(btn);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinned-content"] && !Shopify.designMode) return;
  try {
    
function initPinnedContent(root) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  const scope = root && root.querySelectorAll ? root : document;
  const sections = [];

  if (scope !== document && scope.matches && scope.matches('.pinned-content [data-section-id]')) {
    sections.push(scope);
  }

  scope.querySelectorAll('.pinned-content [data-section-id]').forEach(section => {
    sections.push(section);
  });

  if (window.matchMedia("(min-width: 768px)").matches) {
    sections.forEach(section => {
      if (section.dataset.pinnedContentInitialized === 'true') return;
      section.dataset.pinnedContentInitialized = 'true';
    const itemsWrap = section.querySelector('.pinned-content__items');
    const items = section.querySelectorAll('.pinned-content__item');
    const mediaObjects = section.querySelectorAll('.pinned-content__media-object');
    const mediaContainer = section.querySelector('.pinned-content__media');

    if (!items.length || !mediaObjects.length || !mediaContainer || !itemsWrap) return;

      // Set first media visible
      gsap.set(mediaObjects[0], { opacity: 1 });

      // Fade logic
      items.forEach((item, i) => {
        ScrollTrigger.create({
          trigger: item,
          start: "top center",
          end: "bottom center",
          onEnter:     () => fadeTo(i),
          onEnterBack: () => fadeTo(i)
        });
      });

      function fadeTo(i) {
        gsap.to(mediaObjects,    { opacity: 0, duration: 0.6, ease: "power2.out" });
        gsap.to(mediaObjects[i], { opacity: 1, duration: 0.6, ease: "power2.out" });
      }

      ScrollTrigger.create({
        trigger: itemsWrap,
        start: "top top",
        end: "bottom 80%",
        pin: mediaContainer
      });
    });
  }
}

function runPinnedContentInit(root) {
  if (window.__gsapReady) {
    initPinnedContent(root);
    return;
  }
  window.addEventListener('gsap:ready', function () {
    initPinnedContent(root);
  }, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    runPinnedContentInit(document);
  });
} else {
  runPinnedContentInit(document);
}

document.addEventListener('shopify:section:load', function (event) {
  runPinnedContentInit(event && event.target ? event.target : document);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinned-faqs"] && !Shopify.designMode) return;
  try {
    
// Smooth-scroll the card into view AFTER its open animation completes.
function scrollCardIntoViewWhenReady(card, answerEl) {
  // If it's not open anymore, skip
  if (!card.classList.contains("is-open")) return;

  function doScroll() {
    if (!card.classList.contains("is-open")) return;

    const rect = card.getBoundingClientRect();
    const targetScroll = window.scrollY + rect.top - 100; // offset

    window.scrollTo({
      top: targetScroll,
      behavior: "smooth",
    });
  }

  const style = getComputedStyle(answerEl);
  const dur = parseFloat(style.transitionDuration) || 0;
  const delay = parseFloat(style.transitionDelay) || 0;
  const totalMs = (dur + delay) * 1000;

  if (totalMs === 0) {
    doScroll();
    return;
  }

  let done = false;

  function finish() {
    if (done) return;
    done = true;
    answerEl.removeEventListener("transitionend", onEnd);
    doScroll();
  }

  function onEnd(e) {
    if (e.propertyName === "max-height") finish();
  }

  answerEl.addEventListener("transitionend", onEnd, { once: true });

  setTimeout(finish, totalMs + 50);
}

(() => {
  const sections = document.querySelectorAll(
    '.pinned-faqs__container[data-section-id]'
  );

  sections.forEach((section) => {
    const wrap = section.querySelector(".faq-stack-wrap");
    const cards = [...section.querySelectorAll(".faq-card")];
    const answers = cards.map((c) => c.querySelector(".faq-answer"));
    const triggers = cards.map((c) => c.querySelector(".faq-question"));

    if (!wrap || !cards.length) return;

    wrap.classList.add("stack-enabled");
    let currentIndex = -1;
    const INDEX_RX = /\bfaq-open-\d+\b/g;

    // ---------- helpers ----------
    function setAnswerState(ans, opts) {
      if (!ans) return;
      var open = opts.open;
    
      if (open) {
        ans.hidden = false;
    
        if (getComputedStyle(ans).maxHeight === "none") {
          ans.style.maxHeight = ans.scrollHeight + "px";
        }
    
        ans.style.maxHeight = ans.scrollHeight + "px";
        ans.offsetHeight; 
        ans.style.opacity = "1";
    
      } else {
    
        if (getComputedStyle(ans).maxHeight === "none") {
          ans.style.maxHeight = ans.scrollHeight + "px";
        }
    
        ans.offsetHeight;
        ans.style.maxHeight = "0px";
        ans.style.opacity = "0";
      }
    }

    function closeAll() {
      cards.forEach((card, i) => {
        const ans = answers[i];
        const btn = triggers[i];

        card.classList.remove("is-open");
        btn?.setAttribute("aria-expanded", "false");
        setAnswerState(ans, { open: false });
      });

      wrap.className = wrap.className.replace(INDEX_RX, "").trim();
      currentIndex = -1;
    }

    function openTo(index, { allowToggle = false } = {}) {
      if (allowToggle && index === currentIndex) {
        closeAll();
        return;
      }

      cards.forEach((card, i) => {
        const ans = answers[i];
        const btn = triggers[i];
        const open = i === index;

        card.classList.toggle("is-open", open);
        btn?.setAttribute("aria-expanded", open ? "true" : "false");
        setAnswerState(ans, { open });
      });

      wrap.className = wrap.className.replace(INDEX_RX, "").trim();
      wrap.classList.add(`faq-open-${index}`);

      currentIndex = index;
    }

    // ---------- prep transitions ----------
    answers.forEach((ans, i) => {
      // collapsed baseline
      ans.style.maxHeight = "0px";
      ans.style.opacity = "0";
      ans.hidden = true;

      ans.addEventListener("transitionend", (e) => {
        if (e.propertyName !== "max-height") return;
        const isOpen = cards[i].classList.contains("is-open");

        // once open > free height
        if (isOpen) {
          ans.style.maxHeight = "none";
        } else {
          // fully hidden for a11y
          ans.hidden = true;
        }
      });
    });

    // ---------- click handlers ----------
    triggers.forEach((btn, i) => {
      btn.addEventListener("click", () => {
        const wasOpen = cards[i].classList.contains("is-open");

        // toggle
        openTo(i, { allowToggle: true });

        // If just closed > no scrolling
        if (wasOpen) return;

        scrollCardIntoViewWhenReady(cards[i], answers[i]);
      });
    });

    // ---------- initial open ----------
    requestAnimationFrame(() => {
      openTo(0, { allowToggle: false });
      triggers[0]?.setAttribute("aria-expanded", "true");
      answers[0].hidden = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retailer-banner"] && !Shopify.designMode) return;
  try {
    
function initRetailerBanner(root) {
  if (typeof gsap === 'undefined') return;

  const PAUSE_SECONDS = 4;
  const scope = root && root.querySelectorAll ? root : document;
  const banners = [];

  if (scope !== document && scope.matches && scope.matches('.retailer-banner')) {
    banners.push(scope);
  }

  scope.querySelectorAll('.retailer-banner').forEach((banner) => {
    banners.push(banner);
  });

  banners.forEach((banner) => {
    if (banner.dataset.retailerBannerInitialized === 'true') {
      return;
    }
    banner.dataset.retailerBannerInitialized = 'true';

    const logosWrapper = banner.querySelector('.retailer-banner__logos');
    const logos = Array.from(
      banner.querySelectorAll('.retailer-banner__logo')
    );
    if (!logosWrapper || !logos.length) {
      return;
    }
    const VISIBLE_COUNT = Number(logosWrapper?.dataset.visibleCount) || 5;
    
    // If 5 or fewer, just show them, no animation.
    if (logos.length <= VISIBLE_COUNT) {
      gsap.set(logos, { opacity: 1, y: 0, display: 'flex' });
      return;
    }

    // Chunk into non-overlapping groups of 5
    const groups = [];
    for (let i = 0; i < logos.length; i += VISIBLE_COUNT) {
      groups.push(logos.slice(i, i + VISIBLE_COUNT));
    }

    // Initial state: hide all, show first group
    gsap.set(logos, { opacity: 0, y: 10, display: 'none' });
    let currentIndex = 0;
    let currentSet = groups[currentIndex];
    gsap.set(currentSet, { opacity: 1, y: 0, display: 'flex' });

    function cycle() {
      const nextIndex = (currentIndex + 1) % groups.length;
      const nextSet = groups[nextIndex];

      const tl = gsap.timeline();

      // 1) Hold current group for PAUSE_SECONDS
      tl.to({}, { duration: PAUSE_SECONDS });

      // 2) Fade current group out
      tl.to(currentSet, {
        opacity: 0,
        y: -10,
        duration: 0.4,
        stagger: 0.1,
        ease: 'power3.in',
        onComplete: () => {
          gsap.set(currentSet, { display: 'none' });
        }
      });

      // 3) Fade next group in
      tl.set(nextSet, { display: 'flex', opacity: 0, y: 10 });
      tl.to(nextSet, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.1,
        ease: 'power3.out'
      });

      // 4) Update refs, recurse
      tl.call(() => {
        currentSet = nextSet;
        currentIndex = nextIndex;
        cycle();
      });
    }

    const startLoop = () => {
      if (banner.dataset.loopStarted) return;
      banner.dataset.loopStarted = 'true';
      cycle();
    };

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              startLoop();
              io.disconnect();
            }
          });
        },
        { threshold: 0.25 }
      );
      io.observe(banner);
    } else {
      // Fallback: start immediately
      startLoop();
    }
  });
}

function runRetailerBannerInit(root) {
  if (window.__gsapReady) {
    initRetailerBanner(root);
    return;
  }
  window.addEventListener('gsap:ready', function () {
    initRetailerBanner(root);
  }, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    runRetailerBannerInit(document);
  });
} else {
  runRetailerBannerInit(document);
}

document.addEventListener('shopify:section:load', function (event) {
  runRetailerBannerInit(event && event.target ? event.target : document);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-cards"] && !Shopify.designMode) return;
  try {
    
function initReviewCards(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const viewports = [];

  if (scope !== document && scope.matches && scope.matches(".review-cards__viewport")) {
    viewports.push(scope);
  }

  scope.querySelectorAll(".review-cards__viewport").forEach((viewport) => {
    viewports.push(viewport);
  });

  viewports.forEach((viewport) => {
    const track = viewport && viewport.querySelector(".review-cards__track");
    if (!viewport || !track || viewport.dataset.reviewCardsInitialized === "true") return;

    viewport.dataset.reviewCardsInitialized = "true";

    const isTouch =
      ("ontouchstart" in window) ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    viewport.classList.toggle("reviews--touch", isTouch);
    viewport.classList.toggle("reviews--desktop", !isTouch);

    // Touch: swipe only, no GSAP
    if (isTouch || typeof gsap === "undefined") return;

    // Clone once
    if (!track.dataset.cloned) {
      track.innerHTML += track.innerHTML;
      track.dataset.cloned = "true";
    }

    let loopTl = null;

    const makeLoop = () => {
      // Kill any old tweens/timelines
      if (loopTl) {
        loopTl.kill();
        loopTl = null;
      }
      gsap.killTweensOf(viewport);
      gsap.killTweensOf(track);

      // Hard reset state
      gsap.set(viewport, { autoAlpha: 1 });
      gsap.set(track, { x: 0 });

      const singleWidth = track.scrollWidth / 2;
      const baseDuration = 100;

      loopTl = gsap.timeline({
        repeat: -1,
        defaults: { ease: "none" }
      });

      loopTl
        .to(track, {
          x: -singleWidth,
          duration: baseDuration
        })
        .to(
          viewport,
          {
            autoAlpha: 0,
            duration: 0.5,
            ease: "power2.out"
          },
          ">"
        )
        .set(track, { x: 0 })
        .to(viewport, {
          autoAlpha: 1,
          duration: 0.5,
          ease: "power2.out"
        });
    };

    // Initial build
    makeLoop();

    // Hover slow / resume (listeners added once, using current loopTl)
    viewport.addEventListener("mouseenter", () => {
      if (!loopTl) return;
      gsap.to(loopTl, {
        timeScale: 0,
        duration: 1.4,
        ease: "expo.out"
      });
    });

    viewport.addEventListener("mouseleave", () => {
      if (!loopTl) return;
      gsap.to(loopTl, {
        timeScale: 1,
        duration: 1.2,
        ease: "expo.out"
      });
    });

    // Rebuild on resize (debounced)
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(makeLoop, 300);
    });
  });
}

function runReviewCardsInit(root) {
  if (window.__gsapReady) {
    initReviewCards(root);
    return;
  }
  window.addEventListener("gsap:ready", function () {
    initReviewCards(root);
  }, { once: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    runReviewCardsInit(document);
  });
} else {
  runReviewCardsInit(document);
}

document.addEventListener("shopify:section:load", function (event) {
  runReviewCardsInit(event && event.target ? event.target : document);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  var input = document.querySelector('[data-predictive-search-input]');
  var resultsWrap = document.querySelector('[data-predictive-search-results]');
  var resultsList = document.querySelector('[data-predictive-search-list]');
  var loading = document.querySelector('[data-predictive-search-loading]');
  if (!input || !resultsWrap || !resultsList) return;

  var searchMain = document.querySelector('.search-main');
  var showPrices = searchMain &&
    searchMain.dataset.transactionsEnabled === 'true' &&
    searchMain.dataset.transactionsCountry === 'US';

  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var debounceTimer = null;
  var abortController = null;
  var lastQuery = '';

  input.addEventListener('input', function() {
    var query = input.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsWrap.hidden = true;
      clearResults();
      lastQuery = '';
      return;
    }

    if (query === lastQuery) return;

    debounceTimer = setTimeout(function() {
      fetchResults(query);
    }, 300);
  });

  function clearResults() {
    while (resultsList.firstChild) resultsList.removeChild(resultsList.firstChild);
  }

  function fetchResults(query) {
    if (abortController) abortController.abort();
    abortController = new AbortController();
    lastQuery = query;

    resultsWrap.hidden = false;
    loading.classList.add('is-loading');
    clearResults();

    var url = shopRoot + 'search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,article,page&resources[limit]=6';

    fetch(url, { signal: abortController.signal })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        loading.classList.remove('is-loading');
        renderResults(data, query);
      })
      .catch(function(err) {
        if (err.name !== 'AbortError') {
          loading.classList.remove('is-loading');
          resultsWrap.hidden = true;
        }
      });
  }

  function renderResults(data, query) {
    var resources = data.resources && data.resources.results;
    if (!resources) { renderNoResults(); return; }

    var hasResults = false;

    if (resources.products && resources.products.length) {
      hasResults = true;
      appendGroupTitle('Products');
      resources.products.forEach(function(product) {
        var image = product.image || (product.featured_image && product.featured_image.url) || '';
        var price = showPrices && product.price ? formatMoney(product.price) : '';
        appendItem(product.url, product.title, price, image);
      });
    }

    if (resources.articles && resources.articles.length) {
      hasResults = true;
      appendGroupTitle('Articles');
      resources.articles.forEach(function(article) {
        var image = article.image || (article.featured_image && article.featured_image.url) || '';
        appendItem(article.url, article.title, '', image);
      });
    }

    if (resources.pages && resources.pages.length) {
      hasResults = true;
      appendGroupTitle('Pages');
      resources.pages.forEach(function(page) {
        appendItem(page.url, page.title, '', '');
      });
    }

    if (hasResults) {
      var viewAll = document.createElement('a');
      viewAll.className = 'predictive-search__view-all';
      viewAll.href = shopRoot + 'search?q=' + encodeURIComponent(query);
      viewAll.textContent = 'View all results';
      resultsList.appendChild(viewAll);
    } else {
      renderNoResults();
    }
  }

  function appendGroupTitle(text) {
    var p = document.createElement('p');
    p.className = 'predictive-search__group-title';
    p.textContent = text;
    resultsList.appendChild(p);
  }

  function appendItem(url, title, meta, image) {
    var a = document.createElement('a');
    a.className = 'predictive-search__item' + (image ? '' : ' predictive-search__item--no-image');
    a.href = url;

    if (image) {
      var img = document.createElement('img');
      img.className = 'predictive-search__item-image';
      img.src = image;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 48;
      img.height = 48;
      a.appendChild(img);
    }

    var content = document.createElement('div');
    content.className = 'predictive-search__item-content';

    var titleEl = document.createElement('p');
    titleEl.className = 'predictive-search__item-title';
    titleEl.textContent = title;
    content.appendChild(titleEl);

    if (meta) {
      var metaEl = document.createElement('p');
      metaEl.className = 'predictive-search__item-meta';
      metaEl.textContent = meta;
      content.appendChild(metaEl);
    }

    a.appendChild(content);
    resultsList.appendChild(a);
  }

  function renderNoResults() {
    var p = document.createElement('p');
    p.className = 'predictive-search__no-results';
    p.textContent = 'No results found';
    resultsList.appendChild(p);
  }

  function formatMoney(price) {
    var num = parseFloat(price);
    if (isNaN(num)) return '';
    return '$' + num.toFixed(2);
  }

  // Dismiss the dropdown on Escape or when clicking outside
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && !resultsWrap.hidden) {
      resultsWrap.hidden = true;
      input.focus();
    }
  });

  document.addEventListener('click', function(event) {
    if (resultsWrap.hidden) return;
    if (event.target === input || resultsWrap.contains(event.target)) return;
    resultsWrap.hidden = true;
  });

  // Auto-focus the input on page load if empty
  if (!input.value) {
    input.focus();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplements-product-main"] && !Shopify.designMode) return;
  try {
    
function initSupplementsProductMainPin(root) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (!window.matchMedia('(min-width: 768px)').matches) return;

  var smoother = window.ScrollSmoother && ScrollSmoother.get ? ScrollSmoother.get() : null;
  var scroller = smoother ? smoother.wrapper() : window;
  var scope = root && root.querySelectorAll ? root : document;
  var sections = [];

  if (scope !== document && scope.matches && scope.matches('section.supplements-product-main')) {
    sections.push(scope);
  }
  scope.querySelectorAll('section.supplements-product-main').forEach(function (s) {
    sections.push(s);
  });

  sections.forEach(function (section) {
    if (section.dataset.supplementsProductMainPinned === 'true') return;
    section.dataset.supplementsProductMainPinned = 'true';

    var mediaContainer = section.querySelector('.supplements-product-main__media');
    if (!mediaContainer) return;

    var details = section.querySelector('.supplements-product-main__details');
    if (!details) return;

    // Pin distance = how much taller the details column is than the media
    var pinDistance = function() {
      var detailsBottom = details.offsetTop + details.offsetHeight;
      var mediaBottom = mediaContainer.offsetTop + mediaContainer.offsetHeight;
      return Math.max(0, detailsBottom - mediaBottom);
    };

    ScrollTrigger.create({
      trigger: mediaContainer,
      start: 'top top',
      end: function() { return '+=' + pinDistance(); },
      pin: true,
      scroller: scroller,
      anticipatePin: 1
    });
  });
}

function runSupplementsProductMainPin(root) {
  if (window.__gsapReady) {
    initSupplementsProductMainPin(root);
    return;
  }
  window.addEventListener('gsap:ready', function () {
    initSupplementsProductMainPin(root);
  }, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    runSupplementsProductMainPin(document);
  });
} else {
  runSupplementsProductMainPin(document);
}

document.addEventListener('shopify:section:load', function (event) {
  runSupplementsProductMainPin(event && event.target ? event.target : document);
});

  } catch(e) { console.error(e); }
})();
})();
